import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { Link, useParams, useNavigate } from "react-router-dom";
import Images from "../Images";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import Config from "../Config";
import Loading from "../Components/Loading";
import Table from "../Components/Reports/Table";
import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
  ErrorText,
} from "../Components/Styles/PageStyles";
import NotFoundModel from "../Components/NotFoundModel";
import {
  FieldWrapper,
  InputGroup,
  Label,
  SmallBtn,
} from "../Components/Styles/InputStyles";
//import DeleteModel from "../Components/ContactList/DeleteModel";
import { useSelector } from "react-redux";
import { ForUs } from "../Config";
//import EditDeviceModel from "../Components/ContactList/EditDeviceModel";
import SingleEntry from "../Components/Contacts/SingleEntry";
import { MdAdd } from "react-icons/md";
import { HiUpload } from "react-icons/hi";
import { Field, Form, Formik } from "formik";

const Reports = () => {
  const user = useSelector((state) => state.UserReducer.user);

  const [openUploadModel, setOpenUploadModel] = useState(false);
  const [openDeleteModel, setOpenDeleteModel] = useState(false);
  const [deviceId, setDeviceId] = useState("");

  const [editDevice, setEditDevice] = useState(false);

  const navigate = useNavigate();

  // // ----- Getting Initial Data ------
  // const fetchFunction = async () =>
  //   await axios.get(Config.AdminApi, Config.AxiosConfig);

  // const { isLoading, error, data, refetch, isRefetching } = useQuery(
  //   "adminApi",
  //   fetchFunction
  // );

  const isLoading = "";
  const error = "";
  const data = {
    data: [
      {
        id: 5,
        name: "Test Campaign",
        message:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Eius quae nostrum minima a explicabo eaque, possimus mollitia quidem",
        startDate: "20/10/2022 02:00 pm",
        totalSent: 250,
        totalDelivered: 200,
        status: 1,
      },
      {
        id: 6,
        name: "Test Campaign 2",
        message:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Eius quae nostrum minima a explicabo eaque, possimus mollitia quidem",
        startDate: "20/10/2022 02:00 pm",
        totalSent: 250,
        totalDelivered: 200,
        status: 1,
      },
      {
        id: 7,
        name: "Test Campaign 3",
        message:
          "Lorem ipsum dolor sit amet consectetur adipisicing elit. Eius quae nostrum minima a explicabo eaque, possimus mollitia quidem",
        startDate: "20/10/2022 02:00 pm",
        totalSent: 250,
        totalDelivered: 200,
        status: 1,
      },
    ],
  };
  const refetch = "";
  const isRefetching = "";

  //------ Upload Excel File ------
  const postFunction = async (file) => {
    if (file !== null && file !== undefined) {
      const body = new FormData();
      body.append("file", file[0]);

      return await axios.post(Config.AdminUploadApi, body, {
        headers: {
          authorization: Config.AxiosConfig.headers.authorization,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      });
    } else throw Error("error");
  };

  const onSuccess = (data) => {
    refetch();
    setOpenUploadModel(false);
  };

  const onError = (data) => {
    setOpenUploadModel(false);
  };

  const { isLoading: uploadLoading, mutate: uploadExcelFile } = useMutation(
    postFunction,
    { onSuccess, onError }
  );

  // ------ Delete device ------
  const deleteDeviceHandler = async (id) =>
    await axios.post(
      Config.DeleteDeviceApi,
      { deviceId: id, status: 0 },
      Config.AxiosConfig
    );

  const onDeleteDeviceSuccess = (data) => {
    setOpenDeleteModel(false);
    setDeviceId("");
    refetch();
  };

  const onDeleteDeviceError = (data) => {
    setDeviceId("");
  };

  const { isLoading: deleteDeviceLoading, mutate: deleteDeviceMutate } =
    useMutation(deleteDeviceHandler, {
      onSuccess: onDeleteDeviceSuccess,
      onError: onDeleteDeviceError,
    });

  //------- Add Single Entry -------
  const SingleEntryPostFunction = async (values) =>
    await axios.post(
      Config.AdminUploadSingleEntryApi,
      values,
      Config.AxiosConfig
    );

  const onSingleEntrySuccess = (data) => {
    refetch();
    setDeviceId("");
    setOpenUploadModel(false);
  };

  const onSingleEntryError = (data) => {
    setOpenUploadModel(false);
    setDeviceId("");
  };

  const { isLoading: SingleEntryLoading, mutate: postSingleEntry } =
    useMutation(SingleEntryPostFunction, {
      onSuccess: onSingleEntrySuccess,
      onError: onSingleEntryError,
    });

  //------- Edit Single Entry -------
  const EditSingleEntryFunction = async (values) =>
    await axios.post(Config.AdminEditEntryApi, values, Config.AxiosConfig);

  const onEditEntrySuccess = (data) => {
    refetch();
    setDeviceId("");
    setEditDevice(false);
  };

  const onEditEntryError = (data) => {
    setEditDevice(false);
    setDeviceId("");
  };

  const { isLoading: editEntryLoading, mutate: editSingleEntry } = useMutation(
    EditSingleEntryFunction,
    {
      onSuccess: onEditEntrySuccess,
      onError: onEditEntryError,
    }
  );

  //Get HostNames Province api
  const getHostNamesFunction = async () =>
    await axios.get(Config.GetHostNamesandProvince, Config.AxiosConfig);

  const {
    data: hostNamesandProvince,
    error: hostNamesError,
    isLoading: hostNamesLoading,
  } = useQuery("GetHostNamesandProvince", getHostNamesFunction);
  // end of GetHostNamesandProvince api

  return (
    <Page>
      <BoxContainer>
        <div className="flex w-full justify-between items-center">
          <div>
            <Title>Reports</Title>
            <Underline />
          </div>
          {/* <BoxTitle onClick={() => navigate(-1)}>
            <img src={Images.Arrow} alt="arrow" className="w-2" />
            <p>Admin</p>
          </BoxTitle> */}

          {/* <Uploader setOpenUploadModel={setOpenUploadModel} /> */}
        </div>

        <Filters
          // submitHandler={submitHandler}
          // initialValues={initialValues}
          // InitialLoading={InitialLoading}
          user={user}
        />

        {/* {openDeleteModel && (
          <DeleteModel
            deleteDeviceLoading={deleteDeviceLoading}
            setOpenDeleteModel={setOpenDeleteModel}
            deviceId={deviceId}
            deleteDeviceMutate={deleteDeviceMutate}
          />
        )} */}

        {/* {openUploadModel && (
          <UploadModel
            uploadLoading={uploadLoading}
            setOpenUploadModel={setOpenUploadModel}
            uploadExcelFile={uploadExcelFile}
            postSingleEntry={postSingleEntry}
            SingleEntryLoading={SingleEntryLoading}
          />
        )} */}
        {openUploadModel && (
          <SingleEntry
            postSingleEntry={postSingleEntry}
            SingleEntryLoading={SingleEntryLoading}
            setOpenUploadModel={setOpenUploadModel}
            hostNamesandProvince={hostNamesandProvince}
          />
        )}

        {/* {editDevice && (
          <EditDeviceModel
            editSingleEntry={editSingleEntry}
            editEntryLoading={editEntryLoading}
            setEditDevice={setEditDevice}
            data={data?.data}
            deviceId={deviceId}
          />
        )} */}
        {/* 
        {!isLoading && !isRefetching && (
          <TableWrapper>
            <AdminTable
              ApiData={error ? [] : data?.data}
              setOpenDeleteModel={setOpenDeleteModel}
              setDeviceId={setDeviceId}
              setEditDevice={setEditDevice}
            />
          </TableWrapper>
        )} */}

        <TableWrapper>
          <Table
            ApiData={error ? [] : data?.data}
            setOpenDeleteModel={setOpenDeleteModel}
            setDeviceId={setDeviceId}
            setEditDevice={setEditDevice}
          />
        </TableWrapper>

        {/* {(isLoading || isRefetching) && <Loading />}
        {error && !isLoading && <NotFoundModel />} */}
      </BoxContainer>
    </Page>
  );
};

const Uploader = ({ setOpenUploadModel }) => {
  return (
    <UploadWrapper>
      <Button type="button" onClick={() => setOpenUploadModel(true)}>
        <MdAdd className="text-white w-5 h-5" /> <p>Add Single Contact</p>
      </Button>
      {/* <Button type="button" onClick={() => setOpenUploadModel(true)}>
        <HiUpload className="text-white w-5 h-5" /> <p>Upload Bulk Contact</p>
      </Button> */}
    </UploadWrapper>
  );
};

const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,

  user,
}) => {
  // const [isExportVisible, setIsExportVisible] = useState(false);

  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form>
        <FilterContainer>
          <InputGroup className="max-w-xs">
            <Label htmlFor="startDate">Start Date:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field type="date" name="startDate" id="startDate" class="ml-1" />
            </FieldWrapper>
          </InputGroup>

          <InputGroup className="max-w-xs">
            <Label htmlFor="endDate">End Date:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field type="date" name="endDate" id="endDate" class="ml-1" />
            </FieldWrapper>
          </InputGroup>

          {/* <InputGroup className="max-w-xs">
            <Label>Select Host:</Label>
            <FieldWrapper $select={true} className="h-10">
              <Select
                onChange={(e) => setSelectedHost(e.target.value)}
                value={selectedHost}
                className="w-full h-full pl-2 bg-transparent text-sm p-0  border-none"
              >
                <MenuItem value="All">All Host</MenuItem>
                {hostNamesandProvince?.data?.hostnames.map((hostname) => (
                  <MenuItem value={hostname.hostName}>
                    {hostname.hostName}
                  </MenuItem>
                ))}
              </Select>
            </FieldWrapper>
          </InputGroup> */}

          {/* <InputGroup className="max-w-xs">
            <Label>Select Province:</Label>
            <FieldWrapper $select={true} className="h-10">
              <Select
                onChange={(e) => setSelectedProvince(e.target.value)}
                value={selectedProvince}
                className="w-full h-full pl-2 bg-transparent text-sm p-0  border-none"
              >
                <MenuItem value="All">All Province</MenuItem>

                {hostNamesandProvince?.data?.provinces.map((province) => (
                  <MenuItem value={province.province}>
                    {province.province}
                  </MenuItem>
                ))}
              </Select>
            </FieldWrapper>
          </InputGroup> */}
          <ApplyBtn disabled={InitialLoading} type="submit">
            Apply Filter
          </ApplyBtn>

          {/* <div
            className="relative"
            onClick={() => setIsExportVisible(!isExportVisible)}
            onMouseLeave={() => setIsExportVisible(false)}
          >
            <ExportBtn $active={isExportVisible}>
              <FaFileExport /> <p>Export</p>{" "}
              <MdOutlineKeyboardArrowDown
                className={isExportVisible ? "rotate-180" : ""}
              />
            </ExportBtn>

            {isExportVisible && (
              <ExportWrapper>
                <p
                  className="p-3 border-b border-gray-100 text-sm text-gray-800 px-5 hover:bg-teal-50"
                  disabled={InitialLoading}
                  type="button"
                  onClick={submitHandlerForExport}
                >
                  Export
                </p>

                <p
                  className="p-3 border-b border-gray-100 text-sm text-gray-800 px-5 hover:bg-teal-50"
                  disabled={InitialLoading}
                  type="button"
                  onClick={submitHandlerForExportAll}
                >
                  Export All
                </p>
              </ExportWrapper>
            )}
          </div> */}
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const TableWrapper = tw.h1`my-10 border   rounded-md overflow-auto`;

const FilterContainer = tw.div`
grid grid-cols-2  gap-4 md:flex md:space-x-4 items-end mt-12 md:mt-8`;

const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-gray-500 h-full rounded-md px-6  cursor-pointer hover:bg-gray-100  py-2.5 text-sm`;

const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;

const UploadWrapper = tw.div`
 w-full flex justify-end space-x-4 items-center `;

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-40 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;

export default Reports;
